export default {
  //SUBSTITUI O ARRAY POR UM NOVO
  REFRESH_OPEN_CASHIERS (state, payload) {
    state.open = payload
  }
}
